import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import UploadImage from './components/UploadImage.vue'
import ImageViewer from './components/ImageViewer.vue'
import TableList from './components/TableList.vue'
import RichEditor from './components/RichEditor.vue'

Vue.use(ElementUI)
Vue.component('UploadImage', UploadImage)
Vue.component('ImageViewer', ImageViewer)
Vue.component('TableList', TableList)
Vue.component('RichEditor', RichEditor)

Vue.config.productionTip = false

Vue.prototype.$getDate = (type,date=null,dataTime='T') => {
	const separator = '-'
  const now = date?new Date(date):new Date
  const year = now.getFullYear()
  const month = String(now.getMonth() + 1).padStart(2, '0')
  const day = String(now.getDate()).padStart(2, '0')
  const hours = String(now.getHours()).padStart(2, '0')
  const minutes = String(now.getMinutes()).padStart(2, '0')
  const seconds = String(now.getSeconds()).padStart(2, '0')
  if(type==='date'){
	   return `${year}${separator}${month}${separator}${day}`
  }
  return `${year}${separator}${month}${separator}${day}${dataTime}${hours}:${minutes}:${seconds}`
}

localStorage.removeItem('dynamicRoutesLoaded')

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

document.title = '穗黔物流运输管理后台'
//document.title = '学习'
